//users

import UserList from "../Modules/Users/UserList";
import RolesList from "../Modules/Roles/Presentation/RolesList";

//contacts

import EntitiesList from "../Modules/Entities/EntitiesList";
import ActivityReport from "../Modules/Reports/ActivityReport";

import ContactProfile from "../Modules/Contacts/Presentation/Profile/Index";
import ContactChargeList from "../Modules/Listings/ContactCharges/ContactChargeList";

import JurisdictionList from "../Modules/Listings/Jurisdictions/JurisdictionList";
import PoliticSpaceList from "../Modules/Listings/PoliticSpace/PoliticSpaceList";
import DistrictList from "../Modules/Listings/Districts/DistrictList";

import BlockList from "../Modules/Listings/Blocks/BlockList";
import AreaList from "../Modules/Listings/Areas/AreaList";
import ComissionList from "../Modules/Listings/Comissions/ComissionList";
import EntityProfile from "../Modules/Entities/EntityProfile";
import ContactList from "../Modules/Contacts/Presentation/List/Index";
import AddContact from "../Modules/Contacts/Presentation/Form/Index";
import Citites from "../Modules/Cities/Presentation/Index";
import Provinces from "../Modules/Provinces/Presentation/Index";

export const routes = [
  //Users
  {
    path: `${process.env.PUBLIC_URL}/app/users`,
    Component: <UserList />,
    permission: "list_user",
  },
  {
    path: `${process.env.PUBLIC_URL}/app/roles`,
    Component: <RolesList />,
    permission: "list_user",
  },

  //Contacts
  {
    path: `${process.env.PUBLIC_URL}/app/contacts`,
    Component: <ContactList />,
    permission: "list_contact",
  },
  {
    path: `${process.env.PUBLIC_URL}/app/contacts/add`,
    Component: <AddContact />,
    permission: "create_contact",
  },
  {
    path: `${process.env.PUBLIC_URL}/app/contacts/edit/:id`,
    Component: <AddContact />,
    permission: "edit_contact",
  },
  {
    path: `${process.env.PUBLIC_URL}/app/contacts/detail/:id`,
    Component: <ContactProfile />,
    permission: "list_contact",
  },
  //Entities
  {
    path: `${process.env.PUBLIC_URL}/app/entities`,
    Component: <EntitiesList />,
    permission: "list_entity",
  },
  {
    path: `${process.env.PUBLIC_URL}/app/entities/detail/:id`,
    Component: <EntityProfile />,
    permission: "list_entity",
  },

  //reports
  {
    path: `${process.env.PUBLIC_URL}/app/reports/activity`,
    Component: <ActivityReport />,
    permission: "list_activity",
  },

  //listings
  {
    path: `${process.env.PUBLIC_URL}/app/listings/contact-charges`,
    Component: <ContactChargeList />,
    permission: "list_list",
  },

  {
    path: `${process.env.PUBLIC_URL}/app/listings/jurisdictions`,
    Component: <JurisdictionList />,
    permission: "list_list",
  },
  {
    path: `${process.env.PUBLIC_URL}/app/listings/politic-spaces`,
    Component: <PoliticSpaceList />,
    permission: "list_list",
  },
  {
    path: `${process.env.PUBLIC_URL}/app/listings/districts`,
    Component: <DistrictList />,
    permission: "list_list",
  },
  {
    path: `${process.env.PUBLIC_URL}/app/listings/blocks`,
    Component: <BlockList />,
    permission: "list_list",
  },
  {
    path: `${process.env.PUBLIC_URL}/app/listings/comissions`,
    Component: <ComissionList />,
    permission: "list_list",
  },
  {
    path: `${process.env.PUBLIC_URL}/app/listings/areas`,
    Component: <AreaList />,
    permission: "list_list",
  },
  {
    path: `${process.env.PUBLIC_URL}/app/listings/provinces`,
    Component: <Provinces />,
    permission: "list_list",
  },
  {
    path: `${process.env.PUBLIC_URL}/app/listings/cities`,
    Component: <Citites />,
    permission: "list_list",
  },
];
